const STHENUS_PRIMARY = '#7C3AED';

export const sthenusTheme = {
  token: {
    colorPrimary: STHENUS_PRIMARY,
    colorSuccess: '#166534',
    colorText: '#111827',
    colorTextSecondary: '#6B7280',
    colorBgContainer: '#FFFFFF',
    colorBgLayout: '#F3F4F6',
    colorBorder: '#E5E7EB',
    borderRadius: 12,
  },
  components: {
    Menu: {
      darkItemColor: '#9CA3AF',
      darkItemHoverColor: '#F9FAFB',
      darkItemSelectedColor: STHENUS_PRIMARY,
      darkItemSelectedBg: '#1F1F28',
      darkSubMenuItemBg: '#0B0B0F',
    },
    Table: {
      headerColor: STHENUS_PRIMARY,
      headerBg: '#FFFFFF',
    },
    Button: {
      primaryColor: '#FFFFFF',
    },
    Tag: {
      defaultBg: '#F3F4F6',
      defaultColor: '#6B7280',
    },
    Pagination: {
      itemActiveBg: STHENUS_PRIMARY,
    },
  },
};

export default sthenusTheme;
